import { render } from "./product-single-3.vue?vue&type=template&id=4c78cc4e"
import script from "./product-single-3.vue?vue&type=script&lang=js"
export * from "./product-single-3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__